var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Helper from '../riHelper';
import { BaseService } from "./BaseService";
import Promise from 'bluebird';
import { CacheLayer } from "@/central";
import { NewsService } from './NewsService';
import { TaxonomyHelper } from './TaxonomyHelper';
var NewsletterService = (function (_super) {
    __extends(NewsletterService, _super);
    function NewsletterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewsletterService.prototype.load = function (publishedVersionsOnly) {
        var _this = this;
        if (publishedVersionsOnly === void 0) { publishedVersionsOnly = true; }
        return CacheLayer.simpleLoad(function () {
            return new Promise(function (resolve, reject) {
                Helper.context()
                    .then(function () {
                    var where = [
                        "<BeginsWith>",
                        "<FieldRef Name='ContentTypeId'/>",
                        "<Value Type='Text'>" + _this.contentTypeId + "</Value>",
                        "</BeginsWith>",
                    ].join('');
                    if (publishedVersionsOnly) {
                        where = "<And>" + where + "<Geq><FieldRef Name='_UIVersionString'/><Value Type='Text'>1.0</Value></Geq>" + "</And>";
                    }
                    return _this.loadItemsByQuery([
                        "<Query><Where>",
                        where,
                        "</Where><OrderBy><FieldRef Name=\"" + _this.fieldDate + "\" Ascending=\"FALSE\"/></OrderBy></Query><RowLimit>1</RowLimit>",
                    ].join(''))
                        .then(function (newsletterItems) { resolve(newsletterItems.shift()); });
                })
                    .catch(reject);
            });
        }, "loadNewsletter");
    };
    NewsletterService.prototype.finalizeItem = function (item, spItem, categoryField, list, web, site) {
        var category = TaxonomyHelper.getTermFieldValues(spItem.get_item(this.fieldCategory))[0];
        return NewsService.loadCategoryIcon(categoryField, category).then(function (icon) {
            item.icon = icon;
            item.author = spItem.get_item('Author') && spItem.get_item('Author').get_lookupValue();
            item.category = category && category.get_label();
            return item;
        });
    };
    NewsletterService.prototype.finalizeItems = function (items, list, web, site) {
        return Promise.resolve(items);
    };
    Object.defineProperty(NewsletterService.prototype, "viewFields", {
        get: function () {
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsletterService.prototype, "fieldCategory", {
        get: function () {
            return 'RUBKategorien';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsletterService.prototype, "fieldTitle", {
        get: function () {
            return 'Title';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsletterService.prototype, "fieldTeaser", {
        get: function () {
            return 'anrisstext';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsletterService.prototype, "fieldDate", {
        get: function () {
            return 'Modified';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsletterService.prototype, "fieldEditDate", {
        get: function () {
            return 'Modified';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsletterService.prototype, "urlWeb", {
        get: function () {
            return window.location.href.includes('://dev04:') ? 'aktuelles' : 'rundschreiben';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsletterService.prototype, "urlList", {
        get: function () {
            return 'seiten';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsletterService.prototype, "contentTypeId", {
        get: function () {
            return window.location.href.includes('://dev04:') ? '0x010100C568DB52D9D0A14D9B2FDCC96666E9F2' : '0x010100C568DB52D9D0A14D9B2FDCC96666E9F2007948130EC3DB064584E219954237AF39006CC4E0ABBB5A514AA94993CD5ED02931';
        },
        enumerable: true,
        configurable: true
    });
    return NewsletterService;
}(BaseService));
export { NewsletterService };
